
import api from './api';
import { AxiosInstance } from 'axios';
import { BasicResponse, UploadUrlRequest, UploadUrlResponse, Attachments, GetAttachmentsByType } from '../types/api';

const uploadService = {
  // Get signed URL to upload a file
  getUploadUrl: async (uploadRequest: UploadUrlRequest): Promise<BasicResponse<UploadUrlResponse>> => {
    const response = await (api as AxiosInstance).post('/api/Upload/uploadUrl', uploadRequest);
    return response.data;
  },

  // Retrieve uploaded attachment metadata or download url
  getAttachment: async (attachmentId: number): Promise<BasicResponse<Attachments>> => {
    const response = await (api as AxiosInstance).get(`/api/Upload/getAttachment`, {
      params: { attachmentId },
    });
    return response.data;
  },

  getAttachmentsByType: async (getAttachmentsByType: GetAttachmentsByType): Promise<BasicResponse<Attachments[]>> => {
    const response = await (api as AxiosInstance).get('/api/Upload/getByType', {
      params: getAttachmentsByType,
    });
    return response.data;
  },

  // Confirm uploaded file
  confirmUpload: async (attachmentId: number): Promise<void> => {
    const response = await (api as AxiosInstance).put(`/api/Upload/confirmUpload/${attachmentId}`);
    return;
  },
};

export default uploadService;
